import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import {
    api_v3_update_division_by_id,
    api_v3_generate_playoffs,
} from "../../utils/constants";

import { useNavContext } from "../../context/nav_context";

const PlayoffGenerationModal = ({ division, onClose, onGenerate }) => {
    const { accessToken } = useNavContext();
    const [jsonRules, setJsonRules] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        if (division) {
            const initialRules = {
                divisionId: division.divisionId,
                promotion_rules: (division.promotion_rules && division.promotion_rules.length > 0) ? division.promotion_rules : [
                    { "startRank": 1, "endRank": 1, "action": "DIRECT_ASCEND" },
                    { "startRank": 2, "endRank": 3, "action": "PLAYOFF_ASCEND" }
                ],
                relegation_rules: (division.relegation_rules && division.relegation_rules.length > 0) ? division.relegation_rules : [
                    { "startRank": 6, "endRank": 7, "action": "PLAYOFF_DESCEND" },
                    { "startRank": 8, "endRank": 8, "action": "DIRECT_DESCEND" }
                ],
                tie_breaker_rules: (division.tie_breaker_rules && division.tie_breaker_rules.length > 0) ? division.tie_breaker_rules : [
                    {
                        "type": "PLAY_IN",
                        "description": "Resolve all critical boundary ties with matches"
                    }
                ]
            };
            setJsonRules(JSON.stringify(initialRules, null, 2));
        }
    }, [division]);

    const handleGenerate = async () => {
        setIsLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const parsedRules = JSON.parse(jsonRules);
            const access_token = accessToken || localStorage.getItem("access_token");
            const config = {
                headers: { Authorization: `Bearer ${access_token}` },
            };

            // 1. Update division with rules
            await axios.put(
                api_v3_update_division_by_id(division.divisionId),
                parsedRules,
                config
            );

            // 2. Generate playoffs
            const response = await axios.post(
                api_v3_generate_playoffs(division.divisionId),
                {},
                config
            );

            setSuccess(true);
            if (onGenerate) onGenerate(response.data);

            setTimeout(() => {
                onClose();
            }, 2000);

        } catch (err) {
            console.error(err);
            if (err instanceof SyntaxError) {
                setError("Invalid JSON format");
            } else {
                setError(
                    err.response?.data?.message || "Error generating playoffs"
                );
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Wrapper>
            <div className="modal-content">
                <h3>Generar Playoffs: {division.name}</h3>
                <p>Configura las reglas de promoción y desempate (JSON):</p>
                <textarea
                    value={jsonRules}
                    onChange={(e) => setJsonRules(e.target.value)}
                    rows={15}
                />
                {error && <div className="error-msg">{error}</div>}
                {success && <div className="success-msg">Playoffs generados correctamente!</div>}

                <div className="actions">
                    <button className="btn btn-cancel" onClick={onClose} disabled={isLoading}>
                        Cancelar
                    </button>
                    <button className="btn" onClick={handleGenerate} disabled={isLoading || success}>
                        {isLoading ? "Generando..." : "Generar"}
                    </button>
                </div>
            </div>
        </Wrapper>
    );
};

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .modal-content {
    background: var(--clr-white);
    padding: 2rem;
    border-radius: var(--radius);
    width: 90%;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    color: var(--clr-grey-1);
  }

  textarea {
    width: 100%;
    padding: 0.5rem;
    font-family: monospace;
    resize: vertical;
    border: 1px solid var(--clr-grey-5);
    border-radius: var(--radius);
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
  }

  .btn-cancel {
    background: var(--clr-grey-5);
    color: var(--clr-white);
    &:hover {
      background: var(--clr-grey-4);
    }
  }

  .error-msg {
    color: var(--clr-red-dark);
    background: var(--clr-red-light);
    padding: 0.5rem;
    border-radius: var(--radius);
  }

  .success-msg {
    color: var(--clr-green-dark);
    background: var(--clr-green-light);
    padding: 0.5rem;
    border-radius: var(--radius);
  }
`;

export default PlayoffGenerationModal;
